import * as _ from 'lodash';
import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { useAsyncStatus, useOnMount } from '../../../hooks';
import * as api from '../../../redux/api';
import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';
import List from '../../generic/List';
import ListRowLoading from '../../generic/List/ListRowLoading';
import Text from '../../generic/Text';
import type { BillingTermWithUsageFields } from '../../../../shared/model-typings/billingterm';
import type { FailedFetchResponse } from '../../../helpers/errors';

import AddBillingTermForm from './AddBillingTermForm';
import BillingTermRow from './BillingTermRow';

import styles from './BillingTermCard.module.less';

export const BILLING_TERM_URL = '/api/organization/billing-terms';

const BillingTermCard: VoidFunctionComponent = () => {
  const { status, onError, onPending, onSuccess } = useAsyncStatus();
  const [billingTerms, setBillingTerms] = useState<BillingTermWithUsageFields[]>([]);

  const fetchBillingTerms = async () => {
    onPending();
    try {
      const billingTermRequestResults = await api.get(BILLING_TERM_URL);
      setBillingTerms(billingTermRequestResults.data as BillingTermWithUsageFields[]);
    } catch (err) {
      onError(err as FailedFetchResponse);
    }
    onSuccess();
  };

  useOnMount(fetchBillingTerms);

  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="manage-billing-terms" isInitiallyOpen={false}>
          <Accordion.Target>Manage Billing Terms</Accordion.Target>
          <Accordion.Body>
            <div className={styles.billingTermsCard}>
              <Text.H4>Current Billing Terms</Text.H4>
              <List.Body>
                {status.isLoading && _.times(billingTerms.length || 1, () => (<ListRowLoading />))}
                {!status.isLoading &&
                billingTerms.map((billingTerm) => (
                  <BillingTermRow billingTerm={billingTerm} onRemove={fetchBillingTerms} />
                ))}
              </List.Body>
              <AddBillingTermForm onTermAdd={fetchBillingTerms} />
            </div>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};

export default BillingTermCard;
